var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7974 10.1768L13.824 6.20338M2.40039 21.6004L5.76227 21.2269C6.17301 21.1812 6.37838 21.1584 6.57034 21.0963C6.74064 21.0411 6.90272 20.9632 7.05216 20.8647C7.2206 20.7536 7.36671 20.6075 7.65894 20.3153L20.7775 7.19674C21.8747 6.09951 21.8747 4.32054 20.7775 3.22331C19.6802 2.12608 17.9013 2.12608 16.8041 3.22331L3.68552 16.3418C3.39329 16.6341 3.24718 16.7802 3.13611 16.9486C3.03756 17.0981 2.95966 17.2601 2.90453 17.4304C2.84239 17.6224 2.81957 17.8278 2.77393 18.2385L2.40039 21.6004Z",
    stroke: "#15171E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImage);
export default __webpack_public_path__ + "static/media/edit-image.e720d3d6ea52db744e8702978b8e6de3.svg";
export { ForwardRef as ReactComponent };